import { useApolloClient } from '@apollo/client';
import { Icon, IconSize, Text } from '@bechtel/gds';
import { HEADER_EMULATED_USER_BUN, USER_PROJECT_ID } from '@bechtel/ht-clients-common';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { EmulationActionContainer, UserEmulateIconContainerStyled } from './styled';
export const EmulateAction: FC<{ toggle }> = ({ toggle }) => {
  const navigate = useNavigate();
  const client = useApolloClient();

  const onEmulate = async () => {
    const userBun = prompt(
      `${'Enter User Bun to Emulate:'}${'\n'}${'Enter blank to remove emulation.'}`,
      ''
    )?.toLowerCase();
    if (!userBun) return;
    window.sessionStorage.setItem(HEADER_EMULATED_USER_BUN, userBun.trim());
    // remove saved user project info as emulated user's info needs to come in afresh for this.
    window.sessionStorage.removeItem(USER_PROJECT_ID);
    navigate('/', { replace: true });

    await client.resetStore();
  };

  return (
    <EmulationActionContainer
      onClick={() => {
        if (toggle) toggle();
        // TODO: use it inside useEffect
        setTimeout(() => {
          onEmulate();
        }, 0);
      }}
    >
      <UserEmulateIconContainerStyled>
        <Icon icon="rectangle-terminal" size={IconSize.LARGE} fillColor="green.500" />
      </UserEmulateIconContainerStyled>
      <Text size="250" weight="300" family={'openSansCondensed'}>
        Emulate
      </Text>
    </EmulationActionContainer>
  );
};
